"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "colormap", {
    enumerable: true,
    get: function() {
        return colormap;
    }
});
function colormap(imageData) {
    /**
     * returns the compatible rgba array used in a css linear-gradient
     * colorbar length: 28800 / (15 * 4) = 480
     * example use:     `linear-gradient(1turn, ${colorBar})`;
     */ const { data = [], height = 480, width = 15 } = imageData || {};
    // exit early
    if (data.length < 1) return "#00f, #f00";
    const colorStops = [];
    // Row-Major Order:
    for(let i = 0; i < data.length; i += 4 * width){
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const s = 1 || +(data[i + 3] / 255).toFixed(3);
        const percentage = +(100 * (i / (width * 4)) / height).toFixed(3);
        colorStops.push(`rgba(${r}, ${g}, ${b}, ${s}) ${percentage}%`);
    }
    return `linear-gradient(to bottom, ${colorStops.join(", ")})`;
}
